import achievements from '../mechanics/pages/achievements/routes';
import pointConversion from '../mechanics/pages/pointConversion/routes';
import programMechanics from '../mechanics/pages/programMechanics/routes';
export default [
    ...achievements,
    ...pointConversion,
    ...programMechanics
];